







































































import { Component, Vue } from 'vue-property-decorator';
import { CompanyDetailsModule } from '@/store/modules/companyDetails'
import VerifiableAttribute from '@/components/Shared/VerifiableAttribute.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import CompanyRateCardPositionCreate from '@/components/RateCardPositions/CompanyRateCardPositionCreate.vue';
import CompanyRateCardPositionEdit from '@/components/RateCardPositions/CompanyRateCardPositionEdit.vue';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import RateCardPositionDto from '@/models/RateCardPositions/RateCardPositionDto';

@Component({
  name: 'CompanyRateCardPositions',
  components: { VerifiableAttribute, CompanyRateCardPositionCreate, CompanyRateCardPositionEdit }
})
export default class extends GiganautVue {
    
    get positions() {
        return CompanyDetailsModule.currentRateCard.positions;
    }

    async deleteRateCardPosition(rateCardPosition: RateCardPositionDto) {
        const options: VuetifyConfirmObject = {
                buttonTrueText: "DELETE",
                buttonFalseText: "CANCEL",
                buttonTrueColor: "primary",
                buttonFalseColor: "primary",
            }
        const result = await this.$confirm('Are you sure you want to delete this position?', options);
        if (result) {
            await CompanyDetailsModule.deleteRateCardPosition(rateCardPosition);
        }
  }

}
